export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const UPDATE_USER = 'UPDATE_USER';
export const CHANGE_PASSWORD_USER = 'CHANGE_PASSWORD_USER';

export const GET_ALL_KATEGORI = 'GET_ALL_KATEGORI';
export const GET_ALL_KATEGORI_USER = 'GET_ALL_KATEGORI_USER';
export const GET_KATEGORI_NULL = 'GET_KATEGORI_NULL';
export const ADD_KATEGORI = 'ADD_KATEGORI';
export const DELETE_KATEGORI = 'DELETE_KATEGORI';
export const UPDATE_KATEGORI = 'UPDATE_KATEGORI';
export const GET_KATEGORI_BY_ID = 'GET_KATEGORI_BY_ID';
export const GET_PRODUCT_USER_BY_ID = 'GET_PRODUCT_USER_BY_ID';

export const GET_DATA_NULL = 'GET_DATA_NULL';
export const GET_DATA_BY_KATEGORI = 'GET_DATA_BY_KATEGORI';
export const GET_DATA_BY_SEARCH = 'GET_DATA_BY_SEARCH';
export const GET_PRODUCT_BY_ID = 'GET_PRODUCT_BY_ID';
export const GET_PRODUCT_USER = 'GET_PRODUCT_USER';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';

export const ADD_WISHLIST = 'ADD_WISHLIST';
export const GET_ALL_WISHLIST = 'GET_ALL_WISHLIST';
export const GET_WISHLIST_NULL = 'GET_WISHLIST_NULL';
export const GET_WISHLIST_BY_ID = 'GET_WISHLIST_BY_ID';
export const DELETE_WISHLIST = 'DELETE_WISHLIST';

export const GET_TAWARAN_BUYER = 'GET_TAWARAN_BUYER';
export const GET_TAWARAN_SELLER = 'GET_TAWARAN_SELLER';
export const ADD_TAWARAN = 'ADD_TAWARAN';
export const ADD_STATUS_TAWARAN = 'ADD_STATUS_TAWARAN';
export const GET_TAWARAN_BY_ID = 'GET_TAWARAN_BY_ID';

export const GET_NOTIFIKASI = 'GET_NOTIFIKASI';
